import React from 'react';
var defaultProps = {
  className: ''
};
function FishermanLogo(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    viewBox: "0 0 613.34 154.25",
    fill: "white"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,121V47H52.07V60.83H14.81v15.8H42.29V90.39H14.81V121Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: "62.54",
    y: "46.73",
    width: "15.32",
    height: "61.88"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M62.82,47H77.58v61.31H62.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.51,49.48a34.62,34.62,0,0,1,10.61,7.41l-9.87,9.87q-4.94-5.93-13.82-5.93T108.08,65q-2.47,4.18,0,7.15t11.35,4.45a36.72,36.72,0,0,1,17,6.16q7.65,5.19,7.65,16.54,0,8.88-8.17,15.3a30,30,0,0,1-19,6.41q-10.3,0-17.22-3a37.22,37.22,0,0,1-11.84-7.9l9.87-9.87q4.94,5.93,16.77,6.91,9.89,0,12.32-4.19a7.81,7.81,0,0,0,0-8.39q-2.44-4.2-12.32-5.18A39.81,39.81,0,0,1,98.21,84q-7.41-4.44-7.4-15.3,0-9.83,8.41-15.77T116.52,47Q126.83,47,132.51,49.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.33,121V47h14.81V76.63h34.49V47h14.81v74l-14.81.05V90.44H172.14V121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M237.23,121v-74l54.39,0V60.83H252v15.8H281.7V90.39H252v16.83h39.48V121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.08,88.77,369.54,121h-17l-17.72-30.6H321.33V121H306.52V47H338.8q25.9,0,25.91,21.31Q364.71,84.38,351.08,88.77ZM321.33,76.63h20.72q8.94-.15,9.18-8.15-.24-7.31-9-7.6H321.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M377.24,121V47h4.94l32.07,36.52L446.38,47h4.94v74H436.51l-.05-42.93-22.21,24.67-22.2-24.67V121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M462.17,121l29.62-74h14.8l29.56,74-15.74.05L516,109.69H482.41L478,121Zm37.41-54.28L488.33,94.89h22.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M547.21,121V47h4.93l46.39,46.39V47h14.81v74h-5.43L562,75.15V121Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.12,154.25a1.29,1.29,0,0,1-.4-.07,1.25,1.25,0,0,1-.89-1.4c.43-3.47,0-5.81-1.26-7-.9-.82-2.27-1-4.08-.64,0,0-5.3.4-7.49.58-.27,0-26.58,1.62-42.11-12.21-7-6.26-10.85-14.74-11.35-25.19l.57,0c.49,10.29,4.25,18.64,11.16,24.79,8,7.14,18.91,10,26.65,11.22a76.55,76.55,0,0,0,15,.85c2.19-.18,7.45-.57,7.45-.57,2-.44,3.5-.18,4.55.78,1.41,1.29,1.89,3.8,1.43,7.46a.7.7,0,0,0,.5.79.68.68,0,0,0,.84-.35L148,120.52c-13.19,12-31.88,11.72-32.07,11.73-14.27.49-25-2.58-31.67-9.08a22.64,22.64,0,0,1-7-14.84h.56a22.07,22.07,0,0,0,6.84,14.44c6.61,6.39,17.13,9.39,31.27,8.92.21,0,19.89.3,32.94-12.78l.45.33-18.13,34.32A1.24,1.24,0,0,1,130.12,154.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.58,108.33s0,24.92,38.4,23.64c0,0,19.84.46,33.13-12.86L131,153.43a1,1,0,0,1-1.87-.61c.57-4.54-.1-9.16-5.68-7.93l-7.45.57s-51.2,3.46-53.16-37.13"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: "62.54",
    y: "31.76",
    width: "15.32",
    height: "15.54"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: "62.82",
    y: "32.05",
    width: "14.76",
    height: "14.97"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.2,36.33A18.17,18.17,0,1,1,88.37,18.17,18.19,18.19,0,0,1,70.2,36.33Zm0-26.06a7.9,7.9,0,1,0,7.9,7.9A7.9,7.9,0,0,0,70.2,10.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.2.28A17.89,17.89,0,1,0,88.08,18.17,17.89,17.89,0,0,0,70.2.28Zm0,26.06a8.18,8.18,0,1,1,8.18-8.17A8.18,8.18,0,0,1,70.2,26.34Z"
  }))));
}
export default FishermanLogo;
FishermanLogo.defaultProps = defaultProps;